export default __webpack_public_path__ + "static/media/bird.cf840a01.svg";